const state = {
  queues: [],
  agentsCampaign: [],
  campaignsAgent: [],
  agents: [],
  dialogExten: false,
  errorCalling: false,
  messageStatus: '',
  activeJob: '',
};

export default state;
